/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import BSL_ControlContainer from "./BSL_ControlContainer";

/**
 * Returns the minimum selectable date (local midnight) plus optional forward days.
 * Using native Date avoids timezone-shifts when interacting with date-fns based pickers.
 * @param {number} disableForwardDays
 * @returns {Date}
 */
export function getMinimumDate(disableForwardDays = 0) {
    const d = new Date();
    // normalise to local midnight so comparisons are date-only
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + disableForwardDays);
    return d;
}

/**
 * Validates a date against minimum and weekend rules. Works with Date or date strings.
 */
export function isDateValid(date, { disableForwardDays = 0, enableWeekends = false } = {}) {
    if (!date) return false;
    const d = date instanceof Date ? new Date(date) : new Date(date);
    d.setHours(0, 0, 0, 0);

    const minDate = getMinimumDate(disableForwardDays);
    const isBeforeMin = d < minDate;
    const day = d.getDay();
    const isWeekend = day === 0 || day === 6;

    if (isBeforeMin) return false;
    if (!enableWeekends && isWeekend) return false;
    return true;
}

function disableWeekends(date) {
    return date.getDay() === 0 || date.getDay() === 6;
}

export default function BSL_DatePicker(props) {
    // Ensure minDate and value are plain Date objects (no Moment) — avoids TZ conversion issues
    const minimumDate = props.minDate
        ? props.minDate instanceof Date
            ? props.minDate
            : new Date(props.minDate)
        : getMinimumDate(props.disableForwardDays);

    const pickerValue =
        props.value == null ? new Date() : props.value instanceof Date ? props.value : new Date(props.value);

    return (
        <BSL_ControlContainer {...props}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                    disabled={props.disabled}
                    value={pickerValue}
                    onChange={props.onChange}
                    format={props.format ?? "dd/MM/yyyy"}
                    minDate={minimumDate}
                    variant="inline"
                    disableToolbar
                    style={{ width: "100%" }}
                    shouldDisableDate={props.enableWeekends ? () => false : disableWeekends}
                />
            </MuiPickersUtilsProvider>
        </BSL_ControlContainer>
    );
}
